import axios from 'axios'

/**
 * 获取任务列表
 * @param {*String} options.taskType 任务类型: 4-红外模块老化测试
 */
export const findTasksByInfrared = async () => {
  const { data } = await axios.get(`repower/v1/tasks/list-task?taskType=4`)
  return data
}

/**
 * 获取红外模块老化测试详情（后面跟任务id）
 * @param {*String} id 任务id
 * @param {*String} options.countPerRow 每排单侧设备数量
 */
export const findTestDetile = async (options) => {
  const { id } = options
  const { data } = await axios.get(`repower/v1//tasks/aging-test-communication-module-detile/${id}`, {
    params: {
      countPerRow: 5
    }
  })
  return data
}
